// import components
import { Box, styled, TextField, TextFieldProps } from '@mui/material';

export const StyledMainDatePickerBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative'
}));

export const StyledCustomDatePickerTextField = styled(
  TextField
)<TextFieldProps>(() => ({
  '& .MuiInputAdornment-root': {
    marginLeft: 'auto'
  },
  '& .MuiInputBase-input': {
    width: '75px' // Note: we need to prevent max width due to DatePicker's selection area
  }
}));
